class HeroSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.hero-slider__track');
    this.slides = [...el.querySelectorAll('.hero-slide')];
    this.dots = [...el.querySelectorAll('.hero-slider__dot')];
    this.prevBtn = el.querySelector('.hero-slider__arrow--prev');
    this.nextBtn = el.querySelector('.hero-slider__arrow--next');
    this.current = 0;
    this.total = this.slides.length;
    this.autoplaySpeed = parseInt(el.dataset.autoplay || 5) * 1000;
    this.timer = null;

    this.init();
  }

  init() {
    this.goTo(0);
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
    this.startAutoplay();

    // Pause on hover
    this.el.addEventListener('mouseenter', () => this.stopAutoplay());
    this.el.addEventListener('mouseleave', () => this.startAutoplay());

    // Touch swipe
    this.addSwipe();
  }

  goTo(index) {
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current]?.classList.remove('is-active');

    this.current = (index + this.total) % this.total;

    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    this.slides[this.current].classList.add('is-active');
    this.dots[this.current]?.classList.add('is-active');
  }

  next() { this.goTo(this.current + 1); this.resetAutoplay(); }
  prev() { this.goTo(this.current - 1); this.resetAutoplay(); }

  startAutoplay() {
    if (this.total < 2) return;
    this.timer = setInterval(() => this.next(), this.autoplaySpeed);
  }

  stopAutoplay() { clearInterval(this.timer); }
  resetAutoplay() { this.stopAutoplay(); this.startAutoplay(); }

  addSwipe() {
    let startX = 0;
    this.el.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    this.el.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) diff > 0 ? this.next() : this.prev();
    });
  }
}

document.querySelectorAll('.hero-slider').forEach(el => new HeroSlider(el));